import { Language, Service } from '@yleisradio/areena-types';
import { getTranslation } from 'services/translations';
import styles from './SearchHeader.module.scss';

interface SearchHeaderProps {
  language: Language;
  service: Service;
}

export const SearchHeader: React.FunctionComponent<SearchHeaderProps> = ({
  language,
  service,
}) => {
  const translationKey =
    service === 'tv' ? 'searchHeaderTitleTv' : 'searchHeaderTitleRadio';

  const title = getTranslation(translationKey, language);

  return (
    <header className={styles.search__header}>
      <span>{title}</span>
    </header>
  );
};
